<template>
  <v-card v-if="rows.length" outlined rounded="lg" class="pa-3">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-table</v-icon>
      สาขาวิชาที่เปิดสอน — ผู้เรียนจริงรายละเอียด
      <span v-if="entranceYear" class="section-card-sub">ข้อมูล ณ ปีการศึกษา {{ entranceYear }}</span>
    </div>

    <v-data-table :items="rows" :headers="header" :search="search" dense>
      <template v-slot:top>
        <v-text-field
          v-model="search"
          label="ค้นหา"
          prepend-icon="mdi-magnify"
          dense
          outlined
          hide-details
          class="mb-3"
        ></v-text-field>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// รับข้อมูลจาก parent (collegesid.vue) — ดู stdLevel.vue สำหรับเหตุผลที่เลิก fetch เอง
export default {
  name: "DashboardOvecMasterCollegeMajor",
  props: {
    rows: { type: Array, default: () => [] },
    entranceYear: { type: [String, Number], default: null }
  },
  data() {
    return {
      search: "",
      header: [
        { text: "ประเภทวิชา", align: "center", value: "subjectTypeNameTh" },
        { text: "สาขาวิชา", align: "center", value: "minorNameTh" },
        { text: "ระดับชั้น", align: "center", value: "gradeNameTh" },
        { text: "ปีการศึกษา", align: "center", value: "entranceYear" },
        { text: "จำนวน (คน)", align: "center", value: "cnt" }
      ]
    };
  }
};
</script>

<style scoped>
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-sub {
  margin-left: auto;
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 400;
}
</style>
